import defaultTheme from './default';
import minimalTheme from './minimal';
import compactTheme from './compact';
import darkTheme from './dark';
import islandsTheme from './islands';
import bentoTheme from './bento';
import stepsTheme from './steps';

const themes = {
  default: defaultTheme,
  minimal: minimalTheme,
  compact: compactTheme,
  dark: darkTheme,
  islands: islandsTheme,
  bento: bentoTheme,
  steps: stepsTheme,
};

export const getTheme = (themeName) => themes[themeName] || themes.default;
export const getAvailableThemes = () => Object.keys(themes);
export const getThemeDefaultHighlightColor = (themeName) => {
  const theme = themes[themeName] || themes.default;
  return theme.defaultHighlightColor || '#00d4ff';
};
